import { render } from "./CartComponent.vue?vue&type=template&id=3da3e6a2"
import script from "./CartComponent.vue?vue&type=script&lang=js"
export * from "./CartComponent.vue?vue&type=script&lang=js"

import "./CartComponent.vue?vue&type=style&index=0&id=3da3e6a2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__